import React, { useEffect } from "react";
import moment from "moment";
import * as XLSX from "xlsx";

import PeriodeFilter from "./PeriodeFilter";
import LevelFilter from "./LevelFilter";
import ActionButtons from "./ActionButtons";
import { UserLevel } from "utils/constant";

const FilterSection = ({
  currentUser,
  periodeLaporan,
  setPeriodeLaporan,
  periodeLaporanValue,
  setPeriodeLaporanValue,
  selectedLevel,
  setSelectedLevel,
  levelData,
  levelDataOptions,
  setLevelIdValue,
  selectedProvince,
  setSelectedProvince,
  selectedDistrict,
  setSelectedDistrict,
  selectedFasyankes,
  setSelectedFasyankes,
  handleApplyFilter,
  tableRef,
  showData,
  showFilter,
  setShowFilter,
  levelIdValue,
  reportName = "LAPORAN",
}) => {
  useEffect(() => {
    if (currentUser.level === UserLevel.Fasyankes) {
      setLevelIdValue(currentUser?.fasyankes_id);
    } else if (
      [UserLevel.District, UserLevel.LabTier2].includes(currentUser.level)
    ) {
      setSelectedFasyankes("");
      setLevelIdValue(currentUser?.district_id);
    } else if (
      [UserLevel.Province, UserLevel.LabTier3].includes(currentUser.level)
    ) {
      setSelectedDistrict("");
      setSelectedFasyankes("");
      setLevelIdValue(currentUser?.province_id);
    } else if (currentUser.level === UserLevel.National) {
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedFasyankes("");
    } else {
      setLevelIdValue("");
    }
  }, [selectedLevel]);

  const level =
    selectedLevel.toLowerCase() === "national"
      ? "Nasional"
      : levelIdValue?.split("|")[1];

  const exportToExcel = () => {
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet 1" });
    XLSX.writeFile(
      wb,
      `${reportName}_${level}_${moment().format("DDMMYYYY")}.xlsx`
    );
  };

  return (
    <div className="filter">
      <div className="filter-header">
        <p>FILTER</p>
        <button
          className="btn_toggle_filter"
          onClick={() => setShowFilter(!showFilter)}
        >
          {showFilter ? <span>&#9650;</span> : <span>&#9660;</span>}
        </button>
      </div>
      {showFilter && (
        <div className="filter-body">
          <div className="filter-item">
            <div className="filter-label">
              <p>Periode Laporan</p>
            </div>
            <div className="filter-field">
              <PeriodeFilter
                periodeLaporan={periodeLaporan}
                setPeriodeLaporan={setPeriodeLaporan}
                periodeLaporanValue={periodeLaporanValue}
                setPeriodeLaporanValue={setPeriodeLaporanValue}
              />
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-label">
              <p>Level</p>
            </div>
            <div className="filter-field">
              <LevelFilter
                currentUser={currentUser}
                selectedLevel={selectedLevel}
                setSelectedLevel={setSelectedLevel}
                levelData={levelData}
                levelDataOptions={levelDataOptions}
                setLevelIdValue={setLevelIdValue}
                selectedProvince={selectedProvince}
                setSelectedProvince={setSelectedProvince}
                selectedDistrict={selectedDistrict}
                setSelectedDistrict={setSelectedDistrict}
                selectedFasyankes={selectedFasyankes}
                setSelectedFasyankes={setSelectedFasyankes}
              />
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-field">
              <ActionButtons
                onApply={handleApplyFilter}
                onExport={exportToExcel}
                isExportVisible={showData}
                isDisabled={
                  (periodeLaporan === "monthly" &&
                    (!periodeLaporanValue?.month_start ||
                      !periodeLaporanValue?.month_end)) ||
                  !selectedLevel ||
                  !periodeLaporan ||
                  !periodeLaporanValue ||
                  (selectedLevel.toLowerCase() !== "national" && !levelIdValue)
                }
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSection;
